module.exports = __webpack_public_path__ + "h5/img/live-logo.04fabe17.png";